import React from 'react';
import './Modal.css'; // Import CSS for styling the modal

const Modal = ({ isOpen, onClose, onFileChange }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Load GeoJSON File</h2>
        <input type="file" accept=".geojson" onChange={onFileChange} />
        <button className="close-button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default Modal;
